import { errorSelector, errorTypeSelector } from '../../redux/error/selectors';

export default (state) => ({
  error: errorSelector(state),
  errorType: errorTypeSelector(state),
});
